import { Component, Input } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ValidationService } from "./../../services/validation.service";

@Component({
    selector: 'control-messages',
    template: `
        <div class="text-left">
            <label class="error" *ngIf="errorMessage !== null">{{errorMessage}}</label>
        </div>
    `
})
export class ControlMessagesComponent {
    @Input() control: FormControl;

    constructor() {

    }

    get errorMessage() {
        for ( let propertyName in this.control.errors ) {

            if ( this.control.errors.hasOwnProperty(propertyName) && this.control.touched ) {

                if(propertyName == 'backend'){

                    return this.control.errors[ propertyName ][0];
                }

                return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[ propertyName ]);
            }
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/validation/control-messages.component.ts